<template>
  <VueDraggable v-model="proxiedAdPosts" tag="ul" class="list">
    <li
      v-for="(adPost, index) in proxiedAdPosts"
      :key="index"
      class="list__item"
    >
      <AdPostRuleSetItem
        :adPost="adPost"
        :selected="selected"
        @select-ruleset="$emit('select-ruleset', $event)"
      />
    </li>
  </VueDraggable>
</template>

<script>
import VueDraggable from 'vuedraggable';
import AdPostRuleSetItem from '../AdPostRuleSetItem/AdPostRuleSetItem.vue';

export default {
  name: 'AdPostRuleSetList',
  components: {
    AdPostRuleSetItem,
    VueDraggable,
  },
  props: {
    selected: {
      type: Number,
      default: -1,
    },
    adPosts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    proxiedAdPosts: {
      get() {
        return this.adPosts;
      },
      set(newAdPostList) {
        const adPostOrders = newAdPostList.map((adPost, index) => ({
          adPostId: adPost.id,
          priority: index,
        }));
        this.$emit('reordered-ad-posts', adPostOrders);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  &__item {
    border: 1px solid #ccc;

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}
</style>
